<div class="confirm-modal ig-modal edit-event-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">EXPORT PDF</div>

    <p class="tip">
        Please click the URL to open a PDF version of your itinerary. Once opened, you can print, email, share, etc!
    </p>
    <br>
    <p class="tip">
        <a class="break-all" (click)="openUrl($event)">{{data.url}}</a>
    </p>
    <br>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal.component.html